export const CHANGEBOARDING = 'jira.user.issue.changeboarding.lastinteracted' as const;
export const ATTACHMENTS_VIEW = 'jira.user.issue.attachment.view' as const;
export const SIDEBAR_RESIZE_RATIO = 'jira.user.issue.sidebar.resize-ratio' as const;
export const HIDE_DONE_SUBTASKS_FILTER = 'jira.user.issue.filter.hide-done-subtasks' as const;
export const USER_LAYOUT_PREFERENCE = 'jira.user.issue.user-preferred-layouts' as const;
export const PROACTIVE_COMMENT_SUMMARY_ENABLED =
	'jira.user.issue.comment-summaries.enabled' as const;
export const DETAILS_PANEL_FIELDS_ORDER =
	'jira.user.issue.details.details-panel-fields-order' as const;
export const COMMENT_SLACK_FLAG_DISMISSED = 'jira.user.issue.comment-slack-flag.dismissed' as const;
export const CONTEXT_PANEL_FIELDS_ORDER =
	'jira.user.issue.details.context-panel-fields-order' as const;
// Allow dynamic preference keys, for pinned fields "issue.pinned.PROJECT_KEY"
export type UserPreferences = string;

// Legacy Gira myPreferences
export type MyPreferences = Record<UserPreferences, string | null>;
